// Garde-fou cadeaux Tek Labs (Salepify) : l'app retire les cadeaux après coup,
// un clic rapide sur « Paiement » pouvait partir avec un panier de cadeaux seuls.
// On relit le panier côté serveur, une fois stabilisé, avant chaque passage au checkout.
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isGift = (item) => Object.keys(item.properties || {}).some((key) => key.includes('_salepify'));
  const signature = (cart) => cart.items.map((item) => `${item.key}:${item.quantity}`).join('|');
  const fetchCart = () => fetch(`${root}cart.js`, { cache: 'no-store' }).then((res) => res.json());
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Une suppression peut encore être en cours : on attend deux lectures identiques.
  async function fetchSettledCart() {
    let cart = await fetchCart();
    for (let attempt = 0; attempt < 5; attempt++) {
      await wait(400);
      const next = await fetchCart();
      if (signature(next) === signature(cart)) return next;
      cart = next;
    }
    return cart;
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      event.preventDefault();
      if (submitter.disabled) return;
      submitter.disabled = true;

      try {
        const cart = await fetchSettledCart();
        const gifts = cart.items.filter(isGift);

        if (gifts.length === cart.items.length) {
          if (gifts.length) {
            await fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: Object.fromEntries(gifts.map((item) => [item.key, 0])) }),
            });
          }
          window.location.reload();
          return;
        }

        window.location.href = `${root}checkout`;
      } catch (e) {
        console.error('[TDM gift guard]', e);
        submitter.disabled = false;
      }
    },
    true
  );
})();
